export const domain = 'EntityModel'

export const onInitActivityFeed = `${domain}/onInitActivityFeed`
export const onInitActivityFeedSuccess = `${domain}/onInitActivityFeedSuccess`
export const onInitActivityFeedFailure = `${domain}/onInitActivityFeedFailure`

export const onCloseActivityFeed = `${domain}/onCloseActivityFeed`

